import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
let DropdownComponent = class DropdownComponent {
    model = false;
    group = false;
    styleClass;
    placeholder;
    options = [];
    modelChange = new EventEmitter();
    handleChange($event) {
        this.modelChange.emit($event.value);
    }
    static propDecorators = {
        model: [{ type: Input }],
        group: [{ type: Input }],
        styleClass: [{ type: Input }],
        placeholder: [{ type: Input }],
        options: [{ type: Input }],
        modelChange: [{ type: Output }]
    };
};
DropdownComponent = __decorate([
    Component({
        selector: 'dropdown',
        encapsulation: ViewEncapsulation.None,
        template: `
  <p-dropdown
    [options]="options" [ngModel]="model"
    [placeholder]="placeholder" [group]="group" (onChange)="handleChange($event)">
    <ng-template let-group pTemplate="group">
        <div class="flex align-items-center align-items-baseline">
          <span class="pi pi-camera" style="width: 20px"></span>
          <span>{{ group.label }}</span>
        </div>
    </ng-template>
  </p-dropdown>
  `,
        styles: ["\n    .p-dropdown-item {\n      padding: 0.3rem 2rem !important;\n    }\n    .p-dropdown-item-group {\n      cursor: auto;\n    }\n  "]
    })
], DropdownComponent);
export { DropdownComponent };
